import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { User } from './user.model';

import { EnumTextValuesPipe } from '../../shared/pipes/enum-keys-text.pipe';
import { EnumKeysPipe } from '../../shared/pipes/enum-keys.pipe';

import { UserRole } from '../auth/roles.enum';

@Injectable()
export class UserService {
  userRoleTypes = UserRole;
  userRoleOptions: any;
  userRoleDropDownOptions: any;
  keepSubscriptionsAlive = true;

  constructor(public httpClient: HttpClient,
              private readonly enumTextValuesPipe: EnumTextValuesPipe,
              private readonly enumKeyValuesPipe: EnumKeysPipe) {
  }

  saveUser(user: User) {
    this.editUser(user)
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe({
        error: error => console.log(error)
      });
  }

  setUserRoleOptions() {
    this.userRoleOptions = this.enumTextValuesPipe.transform(this.userRoleTypes, [ '' ]);
  }

  setUserRoleDropDownOptions() {
    this.userRoleDropDownOptions = this.enumKeyValuesPipe.transform(this.userRoleTypes, [ '' ]);
  }

  register(user: User): Observable<User> {
    return this.httpClient.post<User>('/api/user', user);
  }

  login(credentials): Observable<any> {
    return this.httpClient.post<any>('/api/login', credentials);
  }

  getUsers(): Observable<User[]> {
    return this.httpClient.get<User[]>('/api/users');
  }

  getUserFromId(id: string): Observable<User> {
    return this.httpClient.get<User>(`/api/user/${ id }`);
  }

  editUser(user: User): Observable<string> {
    return this.httpClient.put(`/api/user/${ user._id }`, user, { responseType: 'text' });
  }

  deleteUser(user: User): Observable<string> {
    return this.httpClient.delete(`/api/user/${ user._id }`, { responseType: 'text' });
  }
}



// WEBPACK FOOTER //
// ./client/app/core/user/user.service.ts